import React, { useEffect, useState } from 'react';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import Loader from 'react-loader-spinner';
import SearchBar from './SearchBar';
import Song from './Song';
import { useLocation } from 'react-router-dom';
// import ReactSelect from './ReactSelect';

export default function ArtistPage(artistName) {
  const location = useLocation();
  let arg = '';
  if (Object.keys(artistName).length === 0) {
    const search = location.search;
    const params = new URLSearchParams(search);
    const namePassedFromRoute = params.get('name');
    arg = namePassedFromRoute;
    if (!arg) window.location.href = '/';
  } else arg = artistName['artistName'];
  const [name, setName] = useState('');
  const [numberOnes, setNumberOnes] = useState([]);
  const [tens, setTens] = useState([]);
  const [imageURL, setURL] = useState('');
  const [loaded, setLoaded] = useState(false);
  const [view1, toggleView] = useState(true);
  const [data, setData] = useState([]);
  let soloNumberOneSongs = [];
  let soloTensSongs = [];
  let featNumberOneSongs = [];
  let featTensSongs = [];
  const url = `https://no-1-api.herokuapp.com/v3/?artist=${arg}`;

  useEffect(async () => {
    const response = await fetch(url);
    const data = await response.json();
    let URL = data['image_url']
      .replace('"', '')
      .replace('(', '')
      .replace(',', '')
      .replace(')', '')
      .replace("'", '')
      .replace("'", '');
    setLoaded(true);
    let artistName = '';
    for (let key in Object.keys(data)) {
      if (Object.keys(data)[key] !== 'image_url')
        artistName = Object.keys(data)[key];
    }
    let ones = data[artistName]['ones'] !== [] ? data[artistName]['ones'] : [];
    setNumberOnes(Object.keys(ones));
    let tens = data[artistName]['tens'] ? data[artistName]['tens'] : [];
    setTens(Object.keys(tens));
    setURL(URL);
    setData(data[artistName]);
    setName(artistName.replace('-', ' '));
  }, []);

  let toggle = () => {
    toggleView(!view1);
  };

  let isSongSolo = (songName) => {
    let tens = data['tens'];
    let artistsInvolved = '';
    for (var key in tens) {
      if (tens.hasOwnProperty(key) && key === songName) {
        artistsInvolved = tens[key]['Featured'];
      }
    }
    return artistsInvolved.toLowerCase() == name.toLowerCase();
  };

  let separateSongsIntoSoloAndFeatured = () => {
    numberOnes.forEach((song) => {
      if (isSongSolo(song)) soloNumberOneSongs.push(song);
      else featNumberOneSongs.push(song);
    });
    tens.forEach((song) => {
      if (isSongSolo(song)) soloTensSongs.push(song);
      else featTensSongs.push(song);
    });
  };

  separateSongsIntoSoloAndFeatured();

  let no1Bold = view1 ? 'SF-Pro-Display-Bold' : 'SF-Pro-Display-Regular';
  let tenBold = !view1 ? 'SF-Pro-Display-Bold' : 'SF-Pro-Display-Regular';

  return loaded ? (
    tens.length >= 1 ? (
      <div class="ArtistPage">
        {/* <ReactSelect setName={setName} /> */}
        <SearchBar />
        <h2>{name}</h2>
        <img src={imageURL} className="profilePic" />
        <div>
          <ul className="mode">
            <li onClick={toggle} style={{ fontFamily: no1Bold }}>
              No. 1
            </li>
            <li> | </li>
            <li onClick={toggle} style={{ fontFamily: tenBold }}>
              Top Tens
            </li>
          </ul>
        </div>
        <div>
          {view1 ? (
            <div className="numberContainer">
              <p>{numberOnes.length} No. 1 Hits</p>
            </div>
          ) : (
            <div className="numberContainer">
              <p>{tens.length} Top Ten Hits</p>
            </div>
          )}
        </div>
        {/* Insturctions for separating featured vs solo artists:
        in the ArtistPage.js file, before mapping out every song, check if each song's rtistName matches the current artist page (the function from Song.js)
      If true, map on left side, if false, map on right side */}
        {view1 ? (
          numberOnes.length >= 1 ? (
            <div className="columns">
              <div classsName="soloColumn">
                <h3> ––– Solo Artist ––– </h3>
                <div className="songCount">{soloNumberOneSongs.length}</div>
                <ul className="songs">
                  {soloNumberOneSongs.map((song) => {
                    return <Song song={song} data={data} amISolo={true} />;
                  })}
                </ul>
              </div>
              <div className="featColumn">
                <h3> ––– Collaborations ––– </h3>
                <div className="songCount">{featNumberOneSongs.length}</div>
                <ul className="songs">
                  {featNumberOneSongs.map((song) => {
                    return <Song song={song} data={data} amISolo={false} />;
                  })}
                </ul>
              </div>
            </div>
          ) : (
            <p>Currently, {name} has no #1 records.</p>
          )
        ) : (
          <div className="columns">
            <div classsName="soloColumn">
              <h3> ––– Solo Artist ––– </h3>
              <div className="songCount">{soloTensSongs.length}</div>
              <ul className="songs">
                {soloTensSongs.map((song) => {
                  return <Song song={song} data={data} amISolo={true} />;
                })}
              </ul>
            </div>
            <div className="featColumn">
              <h3> ––– Collaborations ––– </h3>
              <div className="songCount">{featTensSongs.length}</div>
              <ul className="songs">
                {featTensSongs.map((song) => {
                  return <Song song={song} data={data} amISolo={false} />;
                })}
              </ul>
            </div>
          </div>
        )}
      </div>
    ) : (
      <div>
        <h1>{name}</h1>
        <img src={imageURL} className="profilePic" />
        <p>Currently, {name} has no #1 or top ten records.</p>
      </div>
    )
  ) : (
    <div>
      <h1>Loading...</h1>
      <p>Compiling all of {arg}'s #1 Hot 100 records</p>
      <Loader type="RevolvingDot" color="#DA73FD" height={100} width={100} />
    </div>
  );
}
